import { useFormContext } from "react-hook-form";
import RadioButton from "@medoma/components/RadioButton/RadioButton";
import RadioButtons from "@medoma/components/RadioButton/RadioButtons";
import type { ICreatePatientNoteFormData } from "./CreatePatientNoteForm";
import { patientNoteTypes, typeDictionary } from "@medoma/models/patientNotes";
import { useLingui } from "@lingui/react/macro";

export const PatientNoteTypePicker = () => {
  const { register } = useFormContext<ICreatePatientNoteFormData>();
  const { t } = useLingui();

  return (
    <RadioButtons orientation="horizontal" legend={t`Anteckningstyp`}>
      {patientNoteTypes.map((type) => (
        <RadioButton
          key={type}
          label={{ text: t(typeDictionary[type]) }}
          visualStyle="framed"
          value={type}
          {...register("anonymisedNote.type")}
        />
      ))}
    </RadioButtons>
  );
};
